import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import {FiMessageCircle} from 'react-icons/fi';

const BOOKING_URL = 'https://links.myvoicelocal.com/widget/bookings/10-minute-call-with-stu';

const VSLHeader = () => (
  <header className="bg-[#faf8f5]/90 backdrop-blur-md border-b border-stone-200/60 sticky top-0 z-40 shadow-sm">
    <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-stone-900 flex items-center justify-center shadow-lg">
          <span className="text-amber-400 font-bold text-lg font-serif">M</span>
        </div>
        <span className="font-semibold text-lg text-stone-900 tracking-tight font-serif">
          MyMD <span className="font-light text-stone-400 italic">Weight Loss</span>
        </span>
      </div>
      <a
        href={BOOKING_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-shrink-0 flex items-center gap-2 bg-stone-900 hover:bg-amber-700 text-white text-xs sm:text-sm font-bold px-4 py-2.5 rounded-full transition-all shadow-lg shadow-stone-900/20"
      >
        <SafeIcon icon={FiMessageCircle} className="text-sm" />
        <span>Speak with Stuart</span>
      </a>
    </div>
  </header>
);

export default VSLHeader;